import { Component, OnInit } from '@angular/core';
// Services
import { GlobalFilterService } from 'src/app/shared/services/global-filter.service';
import Swal from 'sweetalert2';
import { AppCode } from 'src/app/app.code';
import { GlobalFilterParameterModel } from 'src/app/shared/models/global-filter-parameter.model';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-global-filter',
  templateUrl: './global-filter.component.html',
  styleUrls: ['./global-filter.component.css']
})
export class GlobalFilterComponent implements OnInit {
  filterConfigData: any;
  showGlobalFilter: boolean = false;
  globalFilterText: string = "";
  globalFilterImg: string = "";
  globalFilterTextRaw: string = "";
  globalFilterImgRaw: string = "";
  globalFilterAllow: boolean = false;
  filterIconColor: string = "";
  globalFilterEmptyText: string = "";
  constructor(private globalFilterService: GlobalFilterService, private appCode: AppCode, private router: Router, private route: ActivatedRoute) {

    this.globalFilterText = localStorage.getItem('globalFilterText');
    this.globalFilterImg = localStorage.getItem('globalFilterImg');
  }

  ngOnInit() {
    this.createFilterControls();
  }

  ngAfterViewInit() {
    this.globalFilterEmptyText = localStorage.getItem("globalFilterEmptyText");
    if (this.globalFilterText == "" || this.globalFilterText == null) {
      this.globalFilterText = localStorage.getItem("globalFilterEmptyText");
    }
    else {
      this.filterIconColor = "red";
    }
  }

  async createFilterControls() {
    var clientId = await this.appCode.getCurrentClientId();
    var isConfigDataLoaded = false;
    this.filterConfigData = JSON.parse(localStorage.getItem('globalFilterConfigData'));

    if (this.filterConfigData == null || this.filterConfigData == undefined) {
      this.filterConfigData = await this.globalFilterService.getGlobalFilterConfigurationByClientId(parseInt(clientId)).toPromise();
    }
    else {
      isConfigDataLoaded = true;
    }

    if (this.filterConfigData != undefined && this.filterConfigData != null && this.filterConfigData.length > 0) {
      this.globalFilterAllow = true;
      if (!isConfigDataLoaded) {
        for (var c = 0; c < this.filterConfigData.length; c++) {
          this.filterConfigData[c].selectedValue = "0";
          if (this.filterConfigData[c].globalFilterConfigurationParentId == 0) {
            var filterParameter = new GlobalFilterParameterModel();
            filterParameter.clientId = await this.appCode.getCurrentClientId();
            filterParameter.userId = await this.appCode.getCurrentUserId();
            filterParameter.userRoles = await this.appCode.getCurrentUserRoles();
            filterParameter.tblGlobalFilterConfigurationId = this.filterConfigData[c].tblGlobalFilterConfigurationId;

            var dataOptions = await this.globalFilterService.getGlobalFilterDropDownData(filterParameter).toPromise();
            this.filterConfigData[c].options = dataOptions;
          }
        }
        localStorage.setItem('globalFilterConfigData', JSON.stringify(this.filterConfigData));
      }
    }
    else {
      this.globalFilterAllow = false;
    }
  }

  async filterDropdownChanged(event: any, tblGlobalFilterConfigurationId: string) {
    for (var c = 0; c < this.filterConfigData.length; c++) {
      let selectElementText = event.target['options'][event.target['options'].selectedIndex].text;
      console.log(selectElementText);
      if (this.filterConfigData[c].tblGlobalFilterConfigurationId == tblGlobalFilterConfigurationId) {
        this.filterConfigData[c].selectedValue = event.target.value;
        //store selected value in localStorage - this needs to use for individual forms data.
        localStorage.setItem(this.filterConfigData[c].localStorageName, this.filterConfigData[c].selectedValue);
        localStorage.setItem(this.filterConfigData[c].localStorageName + "_Text", selectElementText);

      }
      else if (this.filterConfigData[c].globalFilterConfigurationParentId == tblGlobalFilterConfigurationId) {
        //this is to fetch dropdown-options for child dropdowns.
        this.filterConfigData[c].selectedValue = event.target.value;

        var filterParameter = new GlobalFilterParameterModel();
        filterParameter.clientId = await this.appCode.getCurrentClientId();
        filterParameter.userId = await this.appCode.getCurrentUserId();
        filterParameter.userRoles = await this.appCode.getCurrentUserRoles();
        filterParameter.tblGlobalFilterConfigurationId = this.filterConfigData[c].tblGlobalFilterConfigurationId;
        filterParameter.selectedParentValue = event.target.value;
        var dataOptions = await this.globalFilterService.getGlobalFilterDropDownData(filterParameter).toPromise();
        this.filterConfigData[c].options = dataOptions;
      }
      if (this.filterConfigData[c].selectedValue != "" && this.filterConfigData[c].selectedValue != 0) {
        var selectedOption = this.filterConfigData[c].options.find(w => w.value == this.filterConfigData[c].selectedValue);
        if (selectedOption != undefined) {
          if (this.filterConfigData[c].displaySequence == 1) {
            this.globalFilterImgRaw = selectedOption.logoImage;
            this.globalFilterTextRaw = selectedOption.text;
          }
          else {
            this.globalFilterTextRaw = this.globalFilterTextRaw + ' - ' + selectedOption.text;
          }
        }
      }
    }
    localStorage.setItem('globalFilterConfigData', JSON.stringify(this.filterConfigData));
  }

  showHideGlobalFilter(display: boolean) {
    if (display == true) {
      //this.createFilterControls();
      this.showGlobalFilter = true;
    } else {
      this.showGlobalFilter = false;
    }
  }

  applyGlobalFilter() {
    this.globalFilterImg = this.globalFilterImgRaw;
    this.globalFilterText = this.globalFilterTextRaw;
    this.filterIconColor = "red";

    localStorage.setItem('globalFilterImg', this.globalFilterImg);
    localStorage.setItem('globalFilterText', this.globalFilterText);

    if (this.globalFilterText != "") {
      Swal.fire({
        html: 'Loading data for <br/><br/> <b>' + this.globalFilterText + '</b><br/>',
        showCancelButton: false,
        allowOutsideClick: false
      });
    }
    else
    {
      Swal.fire({
        html: this.globalFilterEmptyText + ' removed. <br/><br/> <b>Loading all data. </b><br/>',
        showCancelButton: false,
        allowOutsideClick: false
      })
    }
    var currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);

    this.showHideGlobalFilter(false);
    
  }

}
